import { useRef, useState } from 'react';

import { RigidBody } from '@react-three/rapier';
import { useFrame } from '@react-three/fiber';
import * as THREE from "three";

import { Tube } from '@game/Tube';

export function BlockSpinner({ position = [0, 0, 0], bad }) {
    const obstacleRef = useRef();
    const [speed] = useState(() => (Math.random() + 0.2) * (Math.random() < 0.5 ? -1 : 1));

    useFrame((state) => {
        const time = state.clock.getElapsedTime();

        const rotation = new THREE.Quaternion();
        rotation.setFromEuler(new THREE.Euler(0, time * speed, 0));
        if (obstacleRef.current) obstacleRef.current.setNextKinematicRotation(rotation);
    })

    return (
        <group position={position}>
            <RigidBody ref={obstacleRef} type="kinematicPosition" position={[0, 0.2, 0]} restitution={0.2} friction={0}>
                <Tube bad={bad} />

                <Tube 
                    bad={bad}
                    position={[0, -0.1, 0]}
                    args={[0.1, 0.3, 0.1]}
                />
            </RigidBody>
        </group>
    )
}